<ion-grid>
  <ion-row>
    <ion-col size="4">
      <carita
        (valueEmit)="cambioCarita($event)"
        setFace="sad"
        [setValue]="2"
        id="'triste'"
        [setPregunta]="setPregunta"
        [elID]="setPregunta"
      ></carita>
    </ion-col>

    <ion-col size="4">
      <carita
        (valueEmit)="cambioCarita($event)"
        setFace="normal"
        [setValue]="1"
        id="'normal'"
        [setPregunta]="setPregunta"
        [elID]="setPregunta"
      ></carita>
    </ion-col>

    <ion-col size="4">
      <carita
        (valueEmit)="cambioCarita($event)"
        setFace="happy"
        [setValue]="0"
        id="'feliz'"
        [setPregunta]="setPregunta"
        [elID]="setPregunta"
      ></carita>
    </ion-col>
  </ion-row>
</ion-grid>
